import settings from 'settings';
import api from '@core/services/api/_api';
import DocumentAssociations from '@core/classes/DocumentAssociation';

export default class PlaidGenerateLinkRequest {
	appDomain: string = settings.appDomain;
	linkToken: string;
	associations: DocumentAssociations[] = [];
	storeCode?: string;
	phoneNumber?: string;
	emailAddress?: string;

	constructor(linkToken: string, associations: DocumentAssociations[], storeCode?: string, phoneNumber?: string, emailAddress?: string) {
		this.linkToken = linkToken;
		this.associations = associations;
		this.storeCode = storeCode;
		this.phoneNumber = phoneNumber;
		this.emailAddress = emailAddress;
	}

	async getPortalLink(): Promise<string> {
		const response = await api.plaid.getPlaidPortalLink(this);
		return response?.data;
	}

	async sendLinkToPortal(): Promise<any> {
		const response = await api.plaid.sendLinkToPortal(this);
		return response?.data;
	}
}
